import { render, staticRenderFns } from "./advertisement-list.vue?vue&type=template&id=2c20689c&scoped=true&"
import script from "./advertisement-list.vue?vue&type=script&lang=js&"
export * from "./advertisement-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c20689c",
  null
  
)

export default component.exports